/* eslint-disable react-hooks/exhaustive-deps */
import { isEmpty } from "lodash-es";
import React, { useEffect, useState } from "react";
import Form from "../../../components/Form";
import Modal, { ModalHeader } from "../../../components/Modal";
import useForm from "../../../hooks/useForm";
import systemAlert from "../../../utils/systemAlert";
import TaxConsultingManagers from "./Managers";
import TaxConsultingAccesses from "./Accesses";
import { BOARD_OPTIONS, COMPANY_EXPOSURE_TYPES, DEFAULT_ROLE_TYPE, EMPLOYEE_EXPOSURE_TYPES, ROLE_TYPES, VISIBILITY_TYPES } from "../../../constants/TaxPortal/TAX_CONSULTING_TYPE";
import { addTaxConsultingBoard, editTaxConsultingBoard, getTaxConsultingContent } from "../../../apis/tax-portal/tax-consulting";
import { findCategoryManager } from "../../../utils/tax-consulting";

const DetailTaxConsulting = (props) => {
  const {
    selectedBoard,
    open,
    setOpen,
    setSelectedBoard,
    submit,
    employee,
    categoryIdx,
  } = props;
  const [mode, setMode] = useState('create');
  const [fields, setFields] = useState([]);
  const [managerOpen, setManagerOpen] = useState(false);
  const [accessOpen, setAccessOpen] = useState(false);
  const [myManager, setMyManager] = useState(null);

  const defaultForm = {
    title: "",// 게시판 이름
    description: "", // 게시판명
    companyExposure: COMPANY_EXPOSURE_TYPES[0].value,
    employeeExposure: EMPLOYEE_EXPOSURE_TYPES[1].value,
    visibility: VISIBILITY_TYPES[0].value,
    role: ROLE_TYPES[2]?.value,
    accesses: [],
    managers: [],
    useOptions: BOARD_OPTIONS.flat(1).reduce((acc, item) => {
      return { ...acc, [item.value]: "true" };
    }, {}),
    companies: [],
    defafultRole: DEFAULT_ROLE_TYPE[1].value,
  };

  const cancel = (e) => {
    if (e) {
      e.preventDefault();
    }
    setOpen(false);
    if (mode !== 'create') {
      setSelectedBoard && setSelectedBoard(null);
    }

    setMyManager(null);
  };

  const _submit = (_form) => {
    const form = {
      categoryIdx: categoryIdx,
      visibility: _form.visibility,
      title: _form.title,
      description: _form.description,
      companyExposure: _form.companyExposure,
      employeeExposure: _form.employeeExposure,
      role: _form.role,
      useOptions: {
        title: true,
        content: _form?.useOptions?.content === "true",
        file: _form?.useOptions?.file === "true",
        comment: _form?.useOptions?.comment === "true",
      },
      defaultRole: _form.defaultRole,
      managers: _form.managers.map(item => {
        return {
          employeeIdx: item.idx,
          isAdmin: item.isAdmin || false,
          isWrite: item.isWrite || false,
          isDelete: item.isDelete || false,
          isPersonalView: item.isPersonalView || false,
        };
      }),
      accesses: _form.accesses.map(item => {
        return {
          employeeIdx: item.idx,
          role: item.role || "READ_LIST"
        };
      }),
      companies: _form.companies.map(item => item.idx),
    };

    if (mode === 'create') {
      systemAlert(`"${form.title}" 게시판을 등록하시겠습니까?`, {

        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '등록',
            onClick: () => {
              addTaxConsultingBoard(form)
                .then(() => {
                  cancel();
                  if (submit) {
                    submit();
                  }
                });
            }
          }
        ]
      });
    } else {
      systemAlert(`"${form.title}" 게시판을 수정하시겠습니까?`, {

        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '승인',
            onClick: () => {
              editTaxConsultingBoard(selectedBoard.idx, form)
                .then(() => {
                  cancel();
                  if (submit) {
                    submit();
                  }
                });
            }
          }
        ]
      });
    }
  };

  const getFields = () => {
    const _fields = [
      [
        { title: "게시판 이름", key: "title", type: "input", required: true, }
      ],
      [
        {
          title: "게시판 설명", key: "description", type: "input",
          // required: true,
        }
      ],

      {
        type: "line",
      },
      {
        type: "title",
        title: "게시판 접근자"
      },
      [
        {
          title: "회사",
          key: "companyExposure",
          type: 'select',
          disabled: employee?.type !== 9 && !myManager?.isAdmin,
          options: {
            list: COMPANY_EXPOSURE_TYPES
          },
          isHide: () => mode === "view"
        },
        {
          title: '회사선택',
          type: "search-companies",
          key: "companies",
          isHide: ({ form }) => {
            return mode === "view" || form.companyExposure !== 'DESIGNATED';
          },
          disabled: employee?.type !== 9 && !myManager?.isAdmin,
        },
      ],
      [
        {
          title: "직원",
          key: "employeeExposure",
          type: 'select',
          disabled: employee?.type !== 9 && !myManager?.isAdmin,
          options: {
            list: EMPLOYEE_EXPOSURE_TYPES
          },
          tooltip: "'대표자'로 설정한 경우 회사별 공개범위가 있으면 해당 회사의 대표자에게만 노출됩니다.\n '지정 직원'인 경우 회사별 공개범위에 관계없이 노출됩니다.",
          isHide: () => mode === "view"
        },
        {
          title: "게시물 접근자",
          key: "accesses",
          type: "button",
          color: "gray-line",
          onValue: (v) => {
            return `설정하기(${!isEmpty(v) ? `${v.length > 1 ? `${v[0].name} 외${v.length - 1}명` : `${v[0].name}`}` : "선택없음"})`;
          },
          disabled: employee?.type !== 9 && !myManager?.isAdmin,
          isHide: ({ form }) => {
            return mode === "view" || form.employeeExposure !== 'DESIGNATED';
          },
          onClick: () => setAccessOpen(true),
        }
      ],
      [
        {
          title: "회사",
          key: "companyExposure",
          onValue: (d) => COMPANY_EXPOSURE_TYPES.find(f => f.value === d)?.label,
          isHide: () => mode !== "view"
        },
        {
          title: '회사선택',
          type: "search-companies",
          key: "companies",
          isHide: ({ form }) => mode !== "view" || form.companyExposure !== 'DESIGNATED',
          disabled: true
        },
      ],
      [
        {
          title: "직원",
          key: "employeeExposure",
          onValue: (d) => EMPLOYEE_EXPOSURE_TYPES.find(f => f.value === d)?.label,
          tooltip: "'대표자'로 설정한 경우 회사별 공개범위가 있으면 해당 회사의 대표자에게만 노출됩니다.\n '지정 직원'인 경우 회사별 공개범위에 관계없이 노출됩니다.",
          isHide: () => mode !== "view"
        },
        {
          title: "게시물 접근자",
          key: "accesses",
          type: "button",
          color: "gray-line",
          onValue: (v) => {
            return `설정하기(${!isEmpty(v) ? `${v.length > 1 ? `${v[0].name} 외${v.length - 1}명` : `${v[0].name}`}` : "선택없음"})`;
          },
          disabled: true,
          isHide: ({ form }) => {
            return mode !== "view" || form.employeeExposure !== 'DESIGNATED';
          },
          onClick: () => setAccessOpen(true),
        }
      ],
      {
        type: "line",
      },
      {
        type: "title",
        title: "게시물 접근자"
      },
      [
        {
          title: "게시물 공개",
          key: "visibility",
          type: "select",
          options: {
            list: VISIBILITY_TYPES,
          },
          isHide: () => mode === "view",
          disabled: employee?.type !== 9 && !myManager?.isAdmin,
        },
        {
          title: "게시물 접근",
          key: "role",
          type: "select",
          tooltip: "지정된 접근회사 혹은 직원의 접근 범위를 결정합니다.",
          options: {
            list: ROLE_TYPES,
          },
          isHide: () => mode === "view",
          disabled: employee?.type !== 9 && !myManager?.isAdmin,
        },
      ],
      [
        {
          title: "접근 범위",
          tooltip: "지정된 접근 회사 혹은 직원 외의 세무사의 노출 여부를 결정합니다.",
          type: "select",
          key: "defaultRole",
          options: {
            list: DEFAULT_ROLE_TYPE,
          },
          disabled: employee?.type !== 9 && !myManager?.isAdmin,
        },
        {
          isHide: ({ form }) => form.defaultRole !== 0,
        }
      ],
      {
        type: "line",
      },
      {
        type: "title",
        title: "게시판 관리자"
      },
      [
        {
          title: "게시판 관리자",
          key: "managers",
          type: "button",
          color: "gray-line",
          disabled: mode === "view" || (employee?.type !== 9 && !myManager?.isAdmin),
          onValue: (v) => {
            return `설정하기(${!isEmpty(v) ? `${v.length > 1 ? `${v[0].name} 외${v.length - 1}명` : `${v[0].name}`}` : "선택없음"})`;
          },
          onClick: () => setManagerOpen(true)
        },

      ],
      {
        type: "line",
      },
      {
        type: "title",
        title: "게시판 기능"
      },
      ...BOARD_OPTIONS.map((boards) => {
        return boards.map(item => {
          return {
            title: `게시물 ${item.label}`,
            type: "radio",
            key: `useOptions.${item.value}`,
            options: {
              list: [
                { label: "사용", value: "true" },
                { label: "미사용", value: "false" },
              ]
            }
          };
        });
      })
    ];

    return _fields;
  };

  const {
    form,
    errors,
    handleSubmit,
    handleOnChange,
    setForm,
    setOriginForm,
    setValidateFields
  } = useForm(
    defaultForm,
    _submit
  );

  useEffect(() => {

    if (employee) {
      getTaxConsultingContent({})
        .then(res => {
          if (!isEmpty(selectedBoard)) {
            const form = {
              ...selectedBoard,
              managers: (selectedBoard?.managers || []).map(item => {
                return {

                  ...item.employee,
                  isAdmin: item.isAdmin || false,
                  isWrite: item.isWrite || false,
                  isDelete: item.isDelete || false,
                  isPersonalView: item.isPersonalView || false,
                };
              }),
              accesses: (selectedBoard?.accesses || []).map(item => {
                return {
                  ...item,
                  ...item.employee,
                };
              }),
              companies: selectedBoard?.companies,
              ...Object.keys(selectedBoard?.useOptions || {}).map(key => {
                return {
                  [key]: selectedBoard?.useOptions[key] + ""
                };
              }).reduce((acc, item) => {
                const [[key, value]] = Object.entries(item);
                return { ...acc, [`useOptions.${key}`]: value };
              }, {})
            };
            const boardManager = selectedBoard?.managers?.find(f => f.employeeIdx === employee.idx);

            if (boardManager) {
              const _myManager = boardManager;
              const isAdmin = _myManager?.isWrite || employee.type === 9;
              form.mode = isAdmin ? 'modify' : 'view';
              setMyManager(_myManager);
              setMode(form.mode);

              setForm(form);
              setOriginForm(form);
            } else {

              const categories = res.categories;
              const _myManager = findCategoryManager(categories, selectedBoard.categoryIdx);
              const isAdmin = _myManager?.isWrite || employee.type === 9;
              form.mode = isAdmin ? 'modify' : 'view';
              setMode(form.mode);
              setMyManager(_myManager);

              setForm(form);
              setOriginForm(form);
            }
          } else {
            const categories = res.categories;
            const _myManager = findCategoryManager(categories, categoryIdx);
            setMyManager(_myManager);
            setForm(defaultForm);
            setOriginForm(defaultForm);
            form.mode = "create";
            setMode(form.mode);
          }
        });
    }
  }, [open, selectedBoard, employee]);


  useEffect(() => {
    if (employee) setFields(getFields());
  }, [mode, employee, myManager]);

  useEffect(() => {
    setValidateFields(fields);
  }, [fields]);

  const managerSubmit = (managers) => {
    setForm({ managers });
    setManagerOpen(false);
  };
  const accessSubmit = (accesses) => {
    setForm({ accesses });
    setAccessOpen(false);
  };

  return (
    <Modal
      isOpen={open}
      close={cancel}
      size="x-lg"
    >
      <div className="client-write">
        <ModalHeader>{selectedBoard ? <>{selectedBoard.title} {mode === 'modify' ? " 수정" : ""} </> : '게시판 생성'} </ModalHeader>
        <Form
          mode={mode}
          form={form}
          errors={errors}
          isRequiredShow={true}
          setForm={setForm}
          fields={fields}
          onChange={handleOnChange}
          submitText={mode === 'create' ? '생성하기' : '수정'}
          submit={handleSubmit}
          cancel={cancel}
        />
      </div>

      <TaxConsultingManagers
        open={managerOpen}
        setOpen={setManagerOpen}
        submit={managerSubmit}
        form={form}
      />
      <TaxConsultingAccesses
        open={accessOpen}
        setOpen={setAccessOpen}
        submit={accessSubmit}
        form={form}
      />
    </Modal>
  );
};

export default DetailTaxConsulting;
